import { RouteConfig } from 'vue-router';

import ProfileExamResults from '@/views/exam/ProfileResults.vue';

export function profileExamResultsRoute(name: string): RouteConfig {
  return {
    path: 'examResults',
    name,
    component: ProfileExamResults,
    meta: {
      title: 'titles.profile.examResult'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (!to.query.order) {
        next({ name: to.name, params: to.params, query: { order: 'date', desc: true } });
      } else {
        next();
      }
    }
  };
}
